(function () {
  'use strict';

  var ROOT_SELECTOR = '.ahe, [class*="hvhd-"], .afg, .ahsi, .ahhs';
  var isApplying = false;
  var scheduled = false;

  var textTranslations = {
    'Skip to content': 'Accéder au contenu',
    '🎁 Special offer: -20% on all canvases ⏰ Limited time! 👉Code: ALPHA20': '🎁 Offre spéciale : -20 % sur toutes les toiles ⏰ Offre limitée ! Code : ALPHA20',
    '🎁 SPECIAL OFFER: -20% ON ALL CANVASES ⏰ LIMITED TIME! 👉CODE: ALPHA20': '🎁 OFFRE SPÉCIALE : -20 % SUR TOUTES LES TOILES ⏰ OFFRE LIMITÉE ! CODE : ALPHA20',
    'Hand-painted reproductions · Photo approval before shipping · Tracked FedEx delivery': 'Reproductions peintes à la main · Validation photo avant expédition · Livraison FedEx suivie',
    'By theme': 'Par thème',
    'Décor & colors': 'Déco & couleurs',
    'By style': 'Par style',
    'Artists': 'Artistes',
    'Museums & countries': 'Musées & pays',
    'Blogs & guides': 'Blog & guides',
    'Custom': 'Sur mesure',
    'LOGIN': 'CONNEXION',
    'Alpha Reproduction · Painting workshop': 'Alpha Reproduction · Atelier de peinture',
    'Search for an artwork, an artist or a mood. Each reproduction is painted in oil on canvas, then photographed before shipping.': 'Choisissez une œuvre, son format et ses finitions. Nos artistes la peignent à l’huile sur toile, puis vous recevez des photos avant l’expédition.',
    'Search': 'Rechercher',
    'Clear': 'Effacer',
    'Try': 'Essayez',
    'The Kiss': 'Le Baiser',
    'Blue landscape': 'Paysage bleu',
    'Renaissance portrait': 'Portrait Renaissance',
    'I prefer to be guided': 'Trouver mon tableau',
    'Painted entirely by hand': 'Peint entièrement à la main',
    'Photo before shipping': 'Photo avant expédition',
    'Customizable dimensions': 'Dimensions personnalisables',
    'Workshop commitments': 'Les engagements de l’atelier',
    'Real oil on canvas': 'Véritable huile sur toile',
    'No digital printing: the material and the gesture remain visible.': 'Aucune impression numérique : la matière et le geste restent visibles.',
    'Your validated painting': 'Votre peinture validée',
    'You receive photos and can request edits.': 'Vous recevez des photos et pouvez demander des retouches.',
    'Your format': 'Votre format',
    'We adapt the dimensions to the proportions of the work and your wall.': 'Nous adaptons les dimensions aux proportions de l’œuvre et à votre mur.',
    'Just get started': 'Choisissez votre point de départ',
    'How do you want to get started?': 'Quel tableau cherchez-vous ?',
    'A specific work, a room to decorate, the desire to explore or a personal project: choose the path that suits you.': 'Une œuvre précise, une pièce à décorer, l’envie d’explorer ou un projet personnel : choisissez le chemin qui vous ressemble.',
    'I know what I’m looking for': 'Je sais ce que je cherche',
    "I know what I'm looking for": 'Je sais ce que je cherche',
    'A specific artwork or artist': 'Une œuvre ou un artiste précis',
    'Start a search': 'Lancer une recherche',
    'For my interior': 'Pour mon intérieur',
    'I’m decorating a room': 'Je décore une pièce',
    "I'm decorating a room": 'Je décore une pièce',
    'Choose for my space': 'Choisir pour mon espace',
    'I let myself be inspired': 'Je me laisse inspirer',
    'I explore art history': 'J’explore l’histoire de l’art',
    'Explore the universes': 'Explorer les univers',
    'Personal project': 'Projet personnel',
    'I want something custom-made': 'Je veux du sur-mesure',
    'Discuss my project': 'Parler de mon projet',
    'Six universes, six presences': 'Œuvres emblématiques',
    'Reference works to start with': 'Des chefs-d’œuvre, peints pour vous',
    'Hand-painted': 'Peint à la main',
    'Configure this reproduction': 'Configurer cette reproduction',
    'Discover famous works': 'Découvrir les œuvres célèbres',
    'Simple and transparent': 'Simple et transparent',
    'From choice to your wall, in three steps': 'Du choix à votre mur, en trois étapes',
    'You choose, you validate, then we protect and ship the canvas.': 'Vous choisissez, vous validez, puis nous protégeons et expédions la toile.',
    'Choose': 'Choisissez',
    'Select a work from the catalog or send your own reference.': 'Sélectionnez une œuvre du catalogue ou envoyez votre propre référence.',
    'Validate': 'Validez',
    'Examine the photos on your canvas and ask for useful edits.': 'Examinez les photos de votre toile et demandez les retouches utiles.',
    'Receive': 'Recevez',
    'The validated paint is protected then shipped with tracking.': 'La peinture validée est protégée puis expédiée avec un suivi.',
    'A work just for you': 'Une œuvre rien que pour vous',
    "Can't find your exact painting?": 'Vous ne trouvez pas exactement votre tableau ?',
    'Send us a title, image or photograph of your space. The workshop will respond to you with a suitable proposal.': 'Envoyez-nous un titre, une image ou une photographie de votre espace. L’atelier vous répondra avec une proposition adaptée.',
    'Talking about my project': 'Parler de mon projet',
    'Hand-painted oil painting reproductions, with photo validation before shipping and tracked delivery.': 'Reproductions de tableaux à l’huile peintes à la main, avec validation photo avant expédition et livraison suivie.',
    'Famous paintings': 'Tableaux célèbres',
    'Painting Styles': 'Styles de peinture',
    'Frequently asked questions': 'Questions fréquentes',
    'Privacy': 'Confidentialité',
    'Terms of Service': 'Conditions générales',
    'Legal notice': 'Mentions légales',
    'Website created by': 'Site internet créé par',
    'Famous Paintings': 'Tableaux célèbres',
    'Essential collections': 'Collections incontournables',
    'Products': 'Tableaux',
    'Blog articles': 'Articles de blog',
    'View selection': 'Voir la sélection',
    'View all results': 'Voir tous les résultats',
    'No result found. Try an artist, style or collection.': 'Aucun résultat trouvé. Essayez un artiste, un style ou une collection.',
    'Loading famous paintings and essential collections...': 'Chargement des peintures connues et des collections incontournables...'
    ,
    'Language': 'Langue',
    'Currency': 'Devise',
    'Selection of hand-painted reproductions': 'Sélection de reproductions peintes à la main'
  };

  var titleTranslations = {
    'The Mona Lisa - Leonardo da Vinci': 'La Joconde – Léonard de Vinci',
    'Mona Lisa - Leonardo da Vinci': 'La Joconde – Léonard de Vinci',
    'Starry Night, F612 - Vincent van Gogh': 'La Nuit étoilée – Vincent van Gogh',
    'The Starry Night - Vincent van Gogh': 'La Nuit étoilée – Vincent van Gogh',
    'The Birth of Venus - Sandro Botticelli': 'La Naissance de Vénus – Sandro Botticelli',
    'The Kiss - Gustav Klimt': 'Le Baiser – Gustav Klimt',
    'The Last Supper - Leonardo da Vinci': 'La Cène – Léonard de Vinci',
    'Impression, Sunrise - Claude Monet': 'Impression, soleil levant – Claude Monet',
    'Girl with a Pearl Earring - Johannes Vermeer': 'La Jeune Fille à la perle – Johannes Vermeer',
    'Water Lilies - Claude Monet': 'Nymphéas – Claude Monet'
  };

  var hrefTranslations = [
    ['/pages/par-theme', 'Par thème'],
    ['/pages/decoration-ambiance', 'Déco & couleurs'],
    ['/pages/decor-ambiance', 'Déco & couleurs'],
    ['/pages/tous-les-styles-de-peinture', 'Par style'],
    ['/pages/peintres-celebres', 'Artistes'],
    ['/pages/par-musee', 'Musées & pays'],
    ['/pages/conseils-inspiration', 'Blog & guides'],
    ['/pages/reproduction-tableau-sur-mesure', 'Sur mesure']
  ];

  function normalized(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function replaceNodeValue(node, value) {
    var current = node.nodeValue || '';
    var leading = current.match(/^\s*/)[0];
    var trailing = current.match(/\s*$/)[0];
    var next = leading + value + trailing;
    if (current !== next) node.nodeValue = next;
  }

  function firstTextNode(element) {
    if (!element) return null;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (normalized(node.nodeValue)) return node;
    }
    return null;
  }

  function setFirstText(element, value) {
    var node = firstTextNode(element);
    if (node) replaceNodeValue(node, value);
  }

  function setText(element, value) {
    if (element && normalized(element.textContent) !== value) element.textContent = value;
  }

  function setHtml(element, value) {
    if (element && normalized(element.textContent) !== normalized(value.replace(/<[^>]+>/g, ' '))) element.innerHTML = value;
  }

  function translateTextNodes(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/i.test(parent.tagName)) continue;
      var key = normalized(node.nodeValue);
      var replacement = textTranslations[key] || titleTranslations[key];
      if (/^Total number of items in the cart:/i.test(key)) replacement = key.replace(/^Total number of items in the cart:/i, 'Nombre total d’articles dans le panier :');
      if (replacement) replaceNodeValue(node, replacement);
      if (/^From\s+/i.test(key)) replaceNodeValue(node, key.replace(/^From\s+/i, 'À partir de '));
    }
  }

  function translateAttributes(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[aria-label], [placeholder], [title], img[alt]').forEach(function (element) {
      ['aria-label', 'placeholder', 'title', 'alt'].forEach(function (attribute) {
        if (!element.hasAttribute(attribute)) return;
        var current = normalized(element.getAttribute(attribute));
        var replacement = textTranslations[current] || titleTranslations[current];
        if (/^Total number of items in the cart:/i.test(current)) replacement = current.replace(/^Total number of items in the cart:/i, 'Nombre total d’articles dans le panier :');
        if (current === 'Customer account') replacement = 'Compte client';
        if (current === 'Desktop menu selected') replacement = 'Navigation principale';
        if (current === 'Close menu') replacement = 'Fermer le menu';
        if (current === 'Open menu') replacement = 'Ouvrir le menu';
        if (replacement && current !== replacement) element.setAttribute(attribute, replacement);
      });
    });
  }

  function translateHeader() {
    /* Les libellés de navigation viennent exclusivement du menu Shopify sélectionné.
       Ne jamais les déduire de l’URL : plusieurs entrées légitimes partagent la même destination. */
    document.querySelectorAll('[class*="hvhd-search-"] input[type="search"], [class*="hvhd-search-"] input[name="q"]').forEach(function (input) {
      input.placeholder = 'Rechercher une œuvre, un artiste ou une collection…';
      input.setAttribute('aria-label', 'Rechercher');
    });
  }

  function translateHomepage() {
    var home = document.querySelector('.ahe');
    if (!home) return;

    setFirstText(home.querySelector('.ahe__hero .ahe__eyebrow'), 'CRÉATION ARTISANALE · SUR MESURE');
    setHtml(home.querySelector('.ahe__lead'), '<p>Choisissez une œuvre, son format et ses finitions. Nos artistes la peignent à l’huile sur toile, puis vous recevez des photos avant l’expédition.</p>');

    var suggestionLabels = ['Essayez', 'Monet', 'Le Baiser', 'Paysage bleu', 'Portrait Renaissance'];
    home.querySelectorAll('.ahe__search-tools > span, .ahe__search-tools > button').forEach(function (element, index) {
      if (suggestionLabels[index]) setText(element, suggestionLabels[index]);
    });
    var searchTools = home.querySelector('.ahe__search-tools');
    if (searchTools) searchTools.setAttribute('aria-label', 'Essayez');

    setFirstText(home.querySelector('.ahe__guided-link'), 'Trouver mon tableau');
    var checks = ['Peint entièrement à la main', 'Photo avant expédition', 'Dimensions personnalisables'];
    home.querySelectorAll('.ahe__checks li').forEach(function (item, index) {
      var nodes = Array.from(item.childNodes).filter(function (node) { return node.nodeType === Node.TEXT_NODE && normalized(node.nodeValue); });
      if (nodes[0] && checks[index]) replaceNodeValue(nodes[0], checks[index]);
    });

    var promises = [
      ['Véritable huile sur toile', 'Aucune impression numérique : la matière et le geste restent visibles.'],
      ['Votre peinture validée', 'Vous recevez des photos et pouvez demander des retouches.'],
      ['Votre format', 'Nous adaptons les dimensions aux proportions de l’œuvre et à votre mur.']
    ];
    home.querySelectorAll('.ahe__promise-grid article').forEach(function (card, index) {
      if (!promises[index]) return;
      setText(card.querySelector('strong'), promises[index][0]);
      setText(card.querySelector('p'), promises[index][1]);
    });
    var promiseGrid = home.querySelector('.ahe__promise-grid');
    if (promiseGrid) promiseGrid.setAttribute('aria-label', 'Trois garanties, un tableau unique');

    var intents = home.querySelector('[id^="AlphaIntents-"]');
    if (intents) {
      setText(intents.querySelector('.ahe__section-head .ahe__eyebrow'), 'CHOISISSEZ VOTRE POINT DE DÉPART');
      setText(intents.querySelector('.ahe__section-head h2'), 'Quel tableau cherchez-vous ?');
      setHtml(intents.querySelector('.ahe__section-intro'), '<p>Une œuvre précise, une pièce à décorer, l’envie d’explorer ou un projet personnel : choisissez le chemin qui vous ressemble.</p>');
      var intentContent = [
        ['Je sais ce que je cherche', 'Une œuvre ou un artiste précis', 'Retrouvez rapidement un titre, un peintre, un style ou une collection.', 'Lancer une recherche'],
        ['Pour mon intérieur', 'Je décore une pièce', 'Choisissez selon la pièce, la lumière, les couleurs et l’effet recherché.', 'Choisir pour mon espace'],
        ['Je me laisse inspirer', 'J’explore l’histoire de l’art', 'Parcourez les artistes, styles, thèmes, pays et grands musées.', 'Explorer les univers'],
        ['Projet personnel', 'Je veux du sur-mesure', 'Une œuvre absente, une photographie ou un format particulier, peint pour vous.', 'Parler de mon projet']
      ];
      intents.querySelectorAll('.ahe__intent').forEach(function (card, index) {
        if (!intentContent[index]) return;
        var body = card.querySelector('.ahe__intent-body');
        setText(body && body.querySelector('small'), intentContent[index][0]);
        setText(body && body.querySelector('strong'), intentContent[index][1]);
        setText(body && body.querySelector(':scope > span'), intentContent[index][2]);
        setFirstText(body && body.querySelector('b'), intentContent[index][3]);
      });
    }

    var works = home.querySelector('.ahe__section--works');
    if (works) {
      setText(works.querySelector('.ahe__eyebrow'), 'ŒUVRES EMBLÉMATIQUES');
      setText(works.querySelector('h2'), 'Des chefs-d’œuvre, peints pour vous');
      setHtml(works.querySelector('.ahe__section-intro'), '<p>Une sélection volontairement courte pour comparer les atmosphères, les époques et les formats sans se perdre dans le catalogue.</p>');
      works.querySelectorAll('.ahe__product-media > span').forEach(function (badge) { setText(badge, 'PEINT À LA MAIN'); });
      works.querySelectorAll('.ahe__product-body > p').forEach(function (price) {
        var value = normalized(price.textContent).replace(/^(From|À partir de)\s+/i, '');
        setText(price, 'À partir de ' + value);
      });
      works.querySelectorAll('.ahe__product-body > a').forEach(function (link) { setFirstText(link, 'Configurer cette reproduction'); });
      setText(works.querySelector('.ahe__center-action .ahe__button'), 'DÉCOUVRIR LES ŒUVRES CÉLÈBRES');
    }

    var process = home.querySelector('.ahe__process');
    if (process) {
      setText(process.querySelector('.ahe__eyebrow'), 'SIMPLE ET TRANSPARENT');
      setText(process.querySelector('h2'), 'Du choix à votre mur, en trois étapes');
      setHtml(process.querySelector('.ahe__section-intro'), '<p>Vous choisissez, vous validez, puis nous protégeons et expédions la toile.</p>');
      var steps = [
        ['Choisissez', 'Sélectionnez une œuvre du catalogue ou envoyez votre propre référence.'],
        ['Validez', 'Examinez les photos de votre toile et demandez les retouches utiles.'],
        ['Recevez', 'La peinture validée est protégée puis expédiée avec un suivi.']
      ];
      process.querySelectorAll('.ahe__steps li').forEach(function (step, index) {
        if (!steps[index]) return;
        setText(step.querySelector('h3'), steps[index][0]);
        setText(step.querySelector('p'), steps[index][1]);
      });
    }

    var closing = home.querySelector('.ahe__closing');
    if (closing) {
      setText(closing.querySelector('.ahe__eyebrow'), 'UNE ŒUVRE RIEN QUE POUR VOUS');
      setText(closing.querySelector('h2'), 'Vous ne trouvez pas exactement votre tableau ?');
      setHtml(closing.querySelector('.ahe__closing-inner > div'), '<p>Envoyez-nous un titre, une image ou une photographie de votre espace. L’atelier vous répondra avec une proposition adaptée.</p>');
      setText(closing.querySelector('.ahe__button'), 'PARLER DE MON PROJET');
    }
  }

  function translateFooter() {
    var footer = document.querySelector('.afg');
    if (!footer) return;
    setText(footer.querySelector('.afg__brand-column > p'), 'Reproductions de tableaux à l’huile peintes à la main, avec validation photo avant expédition et livraison suivie.');
    var footerLinks = [
      ['/collections/boutique', 'Toutes les œuvres'],
      ['/collections/tableaux-celebres', 'Tableaux célèbres'],
      ['/pages/peintres-celebres', 'Artistes'],
      ['/pages/tous-les-styles-de-peinture', 'Styles de peinture'],
      ['/pages/par-musee', 'Musées & pays'],
      ['/pages/par-theme', 'Thèmes'],
      ['/pages/contact', 'Nous contacter'],
      ['/pages/guide-choisir-taille-tableau', 'Choisir la taille'],
      ['/pages/livraison', 'Livraison & suivi'],
      ['/pages/faq', 'Questions fréquentes'],
      ['/pages/retours-retouches', 'Retouches & validation'],
      ['/policies/privacy-policy', 'Confidentialité'],
      ['/policies/terms-of-service', 'Conditions générales'],
      ['/pages/legal-notice', 'Mentions légales']
    ];
    footerLinks.forEach(function (item) {
      footer.querySelectorAll('.afg__grid nav a[href*="' + item[0] + '"], .afg__bottom nav a[href*="' + item[0] + '"]').forEach(function (link) { setText(link, item[1]); });
    });
    setText(footer.querySelector('.afg__credit span'), 'Site internet créé par');
  }

  function translateKnownTitles() {
    document.querySelectorAll('.ahe, .ahsi, .ahhs').forEach(function (root) {
      translateTextNodes(root);
      translateAttributes(root);
    });
  }

  function translateRoutes() {
    document.querySelectorAll('a[href*="/pages/decor-ambiance"]').forEach(function (link) { link.setAttribute('href', '/pages/decoration-ambiance'); });
    document.querySelectorAll('a[href*="/pages/reproduction-of-custom-paintings"]').forEach(function (link) { link.setAttribute('href', '/pages/reproduction-tableau-sur-mesure'); });
  }

  function applyFrench() {
    if (isApplying) return;
    isApplying = true;
    document.documentElement.lang = 'fr';
    translateHeader();
    translateHomepage();
    translateFooter();
    translateKnownTitles();
    translateRoutes();
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      translateTextNodes(root);
      translateAttributes(root);
    });
    translateTextNodes(document.body);
    translateAttributes(document.body);
    isApplying = false;
  }

  function scheduleFrench() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      applyFrench();
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFrench, { once: true });
  } else {
    applyFrench();
  }
  window.addEventListener('load', applyFrench, { once: true });
  document.addEventListener('shopify:section:load', scheduleFrench);

  var observer = new MutationObserver(scheduleFrench);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
